export class SessionRenewalRequiredError extends Error {
  constructor() {
    super("Your session needs to be renewed to finish switching workspaces.");
    this.name = "SessionRenewalRequiredError";
  }
}
